export default __webpack_public_path__ + "static/media/left_bg_arrow_curved_down.baa814fa.png";